<template>
  <validation-observer ref="timesCard">
    <b-card title="Servis Süresi">
      <template v-if="userData.packageLimits[9].limit > 0">
        <template v-for="(item,key) in dataList">
          <b-row
            :key="key"
            match-height
            class="d-flex align-items-center"
          >
            <b-col
              v-if="key > 0"
              cols="12"
            >
              <hr>
            </b-col>
            <b-col
              cols="12"
              md="5"
            >
              <minutes-text :key-number="key" />
            </b-col>
            <b-col
              cols="12"
              md="5"
            >
              <notes-text :key-number="key" />
            </b-col>
            <b-col
              cols="12"
              md="2"
            >
              <b-button
                pill
                variant="flat-danger"
                block
                @click="removeRow(key)"
              >
                <FeatherIcon
                  icon="TrashIcon"
                />
                Sil
              </b-button>
            </b-col>
          </b-row>
        </template>
        <b-card-footer class="pl-0 pr-0 pb-0">
          <div class="d-flex justify-content-between">
            <b-button
              variant="success"
              @click="addRow"
            >
              <FeatherIcon icon="PlusIcon" />
              İçerik Ekle
            </b-button>
            <b-button
              variant="danger"
              :disabled="dataList.length === 0"
              @click="submitForm"
            >
              <FeatherIcon icon="SaveIcon" />
              Kaydet
            </b-button>
          </div>
        </b-card-footer>
      </template>
      <template v-else>
        <b-alert
          variant="warning"
          show
          class="text-center"
        >

          <div class="alert-body">
            <div><feather-icon icon="InfoIcon" /></div>
            Paketiniz bu alanı desteklemiyor.
            <div>
              <small>Bu alanı kullanabilmeniz için üst pakete geçebilirsiniz.</small>
            </div>
          </div>
        </b-alert>
      </template>
    </b-card>
  </validation-observer>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BAlert,
  BButton, BCard, BCardFooter, BCol, BRow,
} from 'bootstrap-vue'
import MinutesText from '@/views/Products/elements/TimesCard/MinutesText.vue'
import NotesText from '@/views/Products/elements/TimesCard/NotesText.vue'

export default {
  name: 'TimesCard',
  components: {
    BAlert,
    BCardFooter,
    BButton,
    BRow,
    BCol,
    BCard,
    MinutesText,
    NotesText,
    ValidationObserver,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productTimes/dataList']
    },
    dataItem() {
      return this.$store.getters['productTimes/dataItem']
    },
    saveData() {
      return this.$store.getters['productTimes/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getData()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.$store.commit('products/SET_LOADING', false)
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      if (this.$route.params.id) {
        this.$store.commit('products/SET_LOADING', true)
        this.$store.dispatch('productTimes/getDataList', this.$route.params.id)
          .then(response => {
            if (response) {
              this.$store.commit('products/SET_LOADING', false)
            }
          })
      }
    },
    addRow() {
      this.dataList.push({
        id: null,
        id_licenses: null,
        minutes: null,
        notes: null,
        id_products: this.$route.params.id,
        id_users: null,
      })
    },
    submitForm() {
      this.$refs.timesCard.validate().then(success => {
        if (success) {
          this.$store.commit('products/SET_LOADING', true)
          this.$store.dispatch('productTimes/saveData', this.dataList)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
      return true
    },
    removeRow(key) {
      if (this.dataList[key].id) {
        this.$store.commit('products/SET_LOADING', true)
        this.$store.dispatch('productTimes/removeData', this.dataList[key].id)
          .then(response => {
            if (response) {
              this.dataList.splice(key, 1)
            }
          })
      } else {
        this.dataList.splice(key, 1)
      }
    },
  },
}
</script>
